export default __webpack_public_path__ + "static/media/Aritzia_Logo.c0e3d3c2.svg";